import {
  workMobileStatusProxy,
  workPsnlworkProxy,
  workApprovalProxy,
} from './index';
// proxy/work/mobile/status/
// proxy/work/psnlwork/
// proxy/work/approval/

/* [ 현황 - work ] */
// 근무기간정보 목록조회
function getWorkTermInfoList(params) {
  return workMobileStatusProxy.get('time/work-term/info/list', { params });
}

// 근무주기조회
function getWorkCycle(params) {
  return workPsnlworkProxy.get('calendar/week/term', { params });
}

// 근무현황 시간정보조회
function getWorkStaTimeInfo(params) {
  return workPsnlworkProxy.get('calendar/info', { params });
}

// 개인근무현황 주단위조회
function getWorkStaWeekList(params) {
  return workMobileStatusProxy.get('time/week/list', { params });
}

// 연장근무보상시간 정보조회 (=잔여휴가조회)
function getWorkOverTimeInfo(params) {
  return workApprovalProxy.get('reward/app/info', { params });
}

// 연장근무보상내역조회
function getWorkOverRewardList(params) {
  return workApprovalProxy.get('reward/app/modal/list', { params });
}

// 부서원근태현황 권한별 목록조회
function getOrgWorkStaByAuthList(params) {
  return workMobileStatusProxy.get('org/list', { params });
}

// 휴가현황 정보조회 (=잔여휴가일조회)
function getHolidayStaInfo(params) {
  return workMobileStatusProxy.get('holiday/info', { params });
}

// 휴가현황 목록조회
function getHolidayStaList(params) {
  return workMobileStatusProxy.get('holiday/list', { params });
}

// 독감예방접종 대상자명 조회
function getVaccinationCode(params) {
  return workApprovalProxy.get('vaccination/det/code', { params });
}

// 독감예방접종 지급기준금액 조회
function getVaccinationPayBaseAmt(params) {
  return workApprovalProxy.get('vaccination/det/base/pay/amt', { params });
}

// 독감예방접종 리스트 조회
function getVaccinationList(params) {
  return workApprovalProxy.get('vaccination/det/list', { params });
}

// 독감예방접종 상세 조회
function getVaccinationDetail(params) {
  return workApprovalProxy.get('vaccination/det/detail', { params });
}

// 독감예방접종 저장
function getVaccinationCostValidChk(params) {
  return workApprovalProxy.get('vaccination/det/cost/vaild/chk', { params });
}

// 독감예방접종 저장
function vaccinationSave(params) {
  return workApprovalProxy.post('vaccination/det/save', { params });
}

// 학자금구분 구분 조회
function getSchClsfiCd(params) {
  return workApprovalProxy.get('edusapp/det/schclsficd', { params });
}

// 학자금구분 대상자 조회
function getEdusAppTgtInfoList(params) {
  return workApprovalProxy.get('edusapp/det/tgt/info/list', { params });
}

// 학자금구분 신청기간 조회
function getBenImplGenList(params) {
  return workApprovalProxy.get('edusapp/det/period/check', { params });
}

// 학자금구분 학년, 분기, 대상자 조회
function getEtcSchClsfiCd(params) {
  return workApprovalProxy.get('edusapp/det/etc/schclsficd', { params });
}

// 독감예방접종 리스트 조회
function getEdusAppList(params) {
  return workApprovalProxy.get('edusapp/det/list', { params });
}

// 학자금신청 상세 조회
function getEdusAppDetail(params) {
  return workApprovalProxy.get('edusapp/det/detail', { params });
}

// 학자금신청 저장
function edusAppSave(params) {
  return workApprovalProxy.post('edusapp/det/save', { params });
}

// 학자금신청 중복체크
function getEdusAppDetDupChk(params) {
  return workApprovalProxy.get('edusapp/det/dup/check', { params });
}

// 휴/복직신청 코드 조회
function getLeaAbsAppApplCdList(params) {
  return workApprovalProxy.get('leaabs/det/applcd/list', { params });
}

// 휴/복직신청 대상자 조회
function getLeaAbsAppDetTgtInfoList(params) {
  return workApprovalProxy.get('leaabs/det/target/list', { params });
}

// 학자금신청 상세 조회
function getLeaAbsAppDetail(params) {
  return workApprovalProxy.get('leaabs/det/detail', { params });
}

// 휴/복직신청 저장
function leaAbsAppSave(params) {
  return workApprovalProxy.post('leaabs/det/save', { params });
}

// 휴/복직신청 신청가능일, 기신청일수 조회
function getLeaAbsEtcDaysAppDet(params) {
  return workApprovalProxy.get('leaabs/det/etc/days', { params });
}

// 휴/복직신청 신청가능일, 복직예정일 조회
function getReturnYmd(params) {
  return workApprovalProxy.get('leaabs/det/etc/returnymd', { params });
}

// 휴/복직신청 유아휴직(연장) 기신청내역 조회
function getExtParLeaDtAppList(params) {
  return workApprovalProxy.get('leaabs/det/parleave/list', { params });
}

// 휴/복직신청 유아휴직(연장) 사용일수 조회
function getExtParLeaAppDetMap(params) {
  return workApprovalProxy.get('leaabs/det/parleave/useday', { params });
}

// 휴/복직신청 유아휴직(연장) 상세 조회
function getExtParLeaDtAppDetMapDetail(params) {
  return workApprovalProxy.get('leaabs/det//ext/par/detail', { params });
}


// 휴/복직신청 유아휴직(추가) 기신청내역 조회
function getExtParAddAppList(params) {
  return workApprovalProxy.get('leaabs/det/parleave/add/list', { params });
}

// 휴/복직신청 유아휴직(추가) 사용일수 조회
function getExtParAddAppDetMap(params) {
  return workApprovalProxy.get('leaabs/det/parleave/add/useday', { params });
}

// 휴/복직신청 유아휴직(추가) 상세 조회
function getExtParAddAppDetMapDetail(params) {
  return workApprovalProxy.get('leaabs/det/ext/par/add/detail', { params });
}


// 휴/복직신청 가족돌봄 체크 조회
function getLeaAbsFamAppDetApplYn(params) {
  return workApprovalProxy.get('leaabs/det/abs/fam/applyn', { params });
}

// 휴일근무대체신청 근무종류 조회
function getHolReplaceAppCode(params) {
  return workApprovalProxy.get('hol/replace/det/code', { params });
}

// 휴일근무대체신청 근무종류 조회
function getHolReplaceAppDetHoliChk(params) {
  return workApprovalProxy.get('hol/replace/det/check', { params });
}

// 휴일근무대체신청  근무시간(휴일) 조회
function getWorkTimeCdList(params) {
  return workApprovalProxy.get('hol/replace/det/time', { params });
}

// 휴일근무대체신청 추계휴게(휴일) 조회
function getRestTimeCdList(params) {
  return workApprovalProxy.get('hol/replace/det/resttime', { params });
}

// 휴일근무대체신청 근무종류 조회
function getHolReplaceAppDetDupCnt(params) {
  return workApprovalProxy.get('hol/replace/det/dup/check', { params });
}

// 휴일근무사전대체신청 저장
function holReplaceSave(params) {
  return workApprovalProxy.post('hol/replace/det/save', { params });
}

// 휴일근무사전대체취소신청 저장
function holReplaceCancelSave(params) {
  return workApprovalProxy.post('hol/replace/det/cancel/save', { params });
}

// 휴일근무사전신청 상세 조회
function getHolReplaceDetail(params) {
  return workApprovalProxy.get('hol/replace/det/detail', { params });
}

// 휴일근무사전취소신청 상세 조회
function getHolReplaceCancelDetail(params) {
  return workApprovalProxy.get('hol/replace/det/cancel/detail', { params });
}

// 휴일근무사전 기신청 조회
function getHolidayymdChgCheck(params) {
  return workApprovalProxy.get('hol/replace/det//chg/check', { params });
}

// 재증명신청 코드 조회
function getReCertAppApplCdList(params) {
  return workApprovalProxy.get('re/cert/applcd/list', { params });
}

// 재직신청 기본 값 조회
function getReCertAppList(params) {
  return workApprovalProxy.get('re/cert/appl/list', { params });
}

// 재직신청 용도 조회
function getPurposeList(params) {
  return workApprovalProxy.get('re/cert/purpose/list', { params });
}

// 휴일근무사전대체취소신청 저장
function saveCertiAppDet(params) {
  return workApprovalProxy.post('re/cert/save', { params });
}

// 재직증명 상세 조회
function getReCertAppDetail(params) {
  return workApprovalProxy.get('re/cert/detail', { params });
}

// 재증명 pdf 조회
function getCertiAppDetCheckPdfExist(params) {
  return workApprovalProxy.get('re/cert/pdf/check', { params });
}

// 재증명 급여 조회
function getCertiAppDetCheck(params) {
  return workApprovalProxy.get('re/cert/pay/check', { params });
}

// 시차출퇴근제신청 코드 조회
function getWorkScheduleTimeCd(params) {
  return workApprovalProxy.get('work/schedule/time/cd/list', { params });
}

// 시차출퇴근제신청 가족사항 체크
function getWorkScheduleResonTermCheck(params) {
  return workApprovalProxy.get('work/schedule/time/reson/term/check', {
    params,
  });
}

// 시차출퇴근제신청 가족사항 체크
function getWorkScheduleAppDetWorkOrg(params) {
  return workApprovalProxy.get('work/schedule/time/work/org', {
    params,
  });
}

// 시차출퇴근제신청 신청기간 조회
function getDayGubun(params) {
  return workApprovalProxy.get('work/schedule/time/day/gubun', {
    params,
  });
}

// 시차출퇴근제신청 시간값 조회
function getTimeInfo(params) {
  return workApprovalProxy.get('work/schedule/time/time/info', {
    params,
  });
}

// 시차출퇴근제신청 시간값서브 조회
function getTimeInfoSub(params) {
  return workApprovalProxy.get('work/schedule/time/time/info/sub', {
    params,
  });
}

// 시차출퇴근제신청 시간값 조회
function getWorkScheduleTimeDate(params) {
  return workApprovalProxy.get('work/schedule/time/date/list', {
    params,
  });
}

// 시차출퇴근제신청 시간값 조회
function getWorkScheduleTimeDay(params) {
  return workApprovalProxy.get('work/schedule/time/day/list', {
    params,
  });
}

// 시차출퇴근제신청 저장
function workScheduleTimeSave(params) {
  return workApprovalProxy.post('work/schedule/time/save', { params });
}

// 시차출퇴근제신청 상세 조회
function getWorkScheduleDetail(params) {
  return workApprovalProxy.get('work/schedule/time/detail', { params });
}

// 시차출퇴근제신청 상세 조회
function getWorkScheduleTimeDayBysearchYm(params) {
  return workApprovalProxy.get('work/schedule/time/day/list/searchym', {
    params,
  });
}

// 시차출퇴근제신청 근태신청 조회
function getWorkScheduleApplYn(params) {
  return workApprovalProxy.get('work/schedule/time/get/applyn', { params });
}

// 설문지 상세 조회
function getBenSurveyDtl(params) {
  return workApprovalProxy.get('survey/dtl', {
    params,
  });
}

// 설문작성 질문항목 목록 조회
function getBenSurveyAppQstItemList(params) {
  return workApprovalProxy.get('survey/qst/item/list', {
    params,
  });
}

// 설문작성 질문항목 목록 조회
function getBenSurveyAppAnsSelItemList(params) {
  return workApprovalProxy.get('survey/ans/item/list', {
    params,
  });
}

// 설문작성 저장
function saveSurveyAnswer(params) {
  return workApprovalProxy.post('survey/save', { params });
}

// 설문작성 체크 저장
function saveSurveyCheckAnswer(params) {
  return workApprovalProxy.post('survey/check/save', { params });
}

// 휴가신청 구분 리스트 조회
function getVacationAppDetGntGubunList(params) {
  return workApprovalProxy.get('vacation/gnt/gubnu/list', { params });
}

// 휴가신청 근태 리스트 조회
function getVacationAppDetGntCdList(params) {
  return workApprovalProxy.get('vacation/gnt/cd/list', { params });
}

// 휴가신청 근태휴일체크 조회
function getVacationAppDetHolidayCnt(params) {
  return workApprovalProxy.get('vacation/holiday/cnt', { params });
}

// 휴가신청 근태 리스트 조회
function getVacationAppUseCdList(params) {
  return workApprovalProxy.get('vacation/use/cd/list', { params });
}

// 휴가신청 근태 리스트 조회
function getVacationAppUseCdList2(params) {
  return workApprovalProxy.get('vacation/use/cd/list2', { params });
}

// 휴가신청 근태휴일체크 조회
function getVacationAppDetValidate(params) {
  return workApprovalProxy.get('vacation/validate/chk', { params });
}

// 휴가신청 신청중인근태 조회
function getApplYnChk(params) {
  return workApprovalProxy.get('vacation/get/applyn', { params });
}

// 휴가신청 저장
function vacationSave(params) {
  return workApprovalProxy.post('vacation/save', { params });
}

// 휴가취소 신청 저장
function cancelSaveVacation(params) {
  return workApprovalProxy.post('vacation/cancel/save', { params });
}

// 휴가신청 근태 리스트 상세 조회
function getVacationAppDetGntCdListDetail(params) {
  return workApprovalProxy.get('vacation/gnt/cd/list/detail', { params });
}

// 휴가신청 상세 조회
function getVacationDetail(params) {
  return workApprovalProxy.get('vacation/detail', { params });
}

// 휴가신청 코드관리 조회
function getTimeCdMgr(params) {
  return workApprovalProxy.get('vacation/time/cd/mgr', { params });
}

// 휴가취소신청 상세 조회
function getVacationCancelDetail(params) {
  return workApprovalProxy.get('vacation/cancel/detail', { params });
}

// 휴가신청 연차 상세 내역 조회
function getVacationMyHoliday(params) {
  return workApprovalProxy.get('vacation/my/holiday', { params });
}

// 휴가신청 연차 내역 리스트 조회
function getVacationMyHolidayList(params) {
  return workApprovalProxy.get('vacation/my/holiday/list', { params });
}

// 남성,여성 조회
function getGenderNm(params) {
  return workApprovalProxy.get('vacation/get/genderNm', { params });
}

// 설문조사 seqno 조회
function getSurveySeqNo(params) {
  return workApprovalProxy.get('survey/get/seqno', { params });
}

function getEdusAppDetTgtInfoList(params) {
  return workApprovalProxy.get('vacation/tgt/info', { params });
}

function getLeaAbsEtcAppDetApplYn(params) {
  return workApprovalProxy.get('leaabs/det/etc/applyn', { params });
}

function getLeaAbsAppMap(params) {
  return workApprovalProxy.get('leaabs/det/abs/app', { params });
}

function getLeaAbsAppStatusCd(params) {
  return workApprovalProxy.get('leaabs/det/abs/app/statuscd', { params });
}

function getRemainDaysBefore(params) {
  return workApprovalProxy.get('leaabs/det/remain/days/before', { params });
}

// 휴복직 결제선 조회
function getLeaAbsAppDetApplLvlCode(params) {
  return workApprovalProxy.get('leaabs/det/appl/lvl/code', { params });
}

// 근태 신청 유효성체크
function getVacationAppDetLogicCheck(params) {
  return workApprovalProxy.get('vacation/logic/check', { params });
}

export {
  getWorkTermInfoList,
  getWorkCycle,
  getWorkStaTimeInfo,
  getWorkStaWeekList,
  getWorkOverTimeInfo,
  getWorkOverRewardList,
  getOrgWorkStaByAuthList,
  getHolidayStaInfo,
  getHolidayStaList,
  getVaccinationCode,
  getVaccinationPayBaseAmt,
  vaccinationSave,
  getSchClsfiCd,
  getEtcSchClsfiCd,
  edusAppSave,
  getEdusAppDetDupChk,
  getLeaAbsAppApplCdList,
  getLeaAbsAppDetTgtInfoList,
  leaAbsAppSave,
  getLeaAbsEtcDaysAppDet,
  getReturnYmd,
  getExtParLeaDtAppList,
  getExtParLeaAppDetMap,
  getExtParAddAppList,
  getExtParAddAppDetMap,
  getVaccinationDetail,
  getEdusAppDetail,
  getLeaAbsAppDetail,
  getVaccinationCostValidChk,
  getVaccinationList,
  getEdusAppList,
  getHolReplaceAppCode,
  getHolReplaceAppDetHoliChk,
  getWorkTimeCdList,
  getRestTimeCdList,
  getHolReplaceAppDetDupCnt,
  holReplaceSave,
  getHolReplaceDetail,
  getBenImplGenList,
  holReplaceCancelSave,
  getHolReplaceCancelDetail,
  getReCertAppApplCdList,
  getReCertAppList,
  getPurposeList,
  saveCertiAppDet,
  getReCertAppDetail,
  getCertiAppDetCheckPdfExist,
  getCertiAppDetCheck,
  getWorkScheduleTimeCd,
  getWorkScheduleResonTermCheck,
  getWorkScheduleAppDetWorkOrg,
  getDayGubun,
  getTimeInfo,
  getWorkScheduleTimeDate,
  getWorkScheduleTimeDay,
  getTimeInfoSub,
  workScheduleTimeSave,
  getWorkScheduleDetail,
  getWorkScheduleTimeDayBysearchYm,
  getBenSurveyDtl,
  getBenSurveyAppQstItemList,
  getBenSurveyAppAnsSelItemList,
  saveSurveyAnswer,
  saveSurveyCheckAnswer,
  getVacationAppDetGntGubunList,
  getVacationAppDetGntCdList,
  getVacationAppDetHolidayCnt,
  getVacationAppUseCdList,
  getVacationAppDetValidate,
  getApplYnChk,
  vacationSave,
  getWorkScheduleApplYn,
  getHolidayymdChgCheck,
  getVacationAppDetGntCdListDetail,
  getVacationDetail,
  getVacationMyHoliday,
  getVacationMyHolidayList,
  cancelSaveVacation,
  getVacationCancelDetail,
  getTimeCdMgr,
  getGenderNm,
  getSurveySeqNo,
  getEdusAppDetTgtInfoList,
  getEdusAppTgtInfoList,
  getLeaAbsEtcAppDetApplYn,
  getLeaAbsAppMap,
  getLeaAbsAppStatusCd,
  getRemainDaysBefore,
  getExtParLeaDtAppDetMapDetail,
  getExtParAddAppDetMapDetail,
  getLeaAbsFamAppDetApplYn,
  getLeaAbsAppDetApplLvlCode,
  getVacationAppUseCdList2,
  getVacationAppDetLogicCheck,
};
